import React from 'react'
import styled from 'styled-components'
import { message } from 'antd'
import { containerIds } from 'modules/ui'
import { wwwUrl } from 'frontend_core/dist/helpers/url'
import { redirectTo } from 'frontend_core/dist/helpers/http'
import Path from 'routes/path'
import renderUIError from 'helper/renderUIError'

export default class SignupForm extends React.Component {
  onUserChange = e => {
    const { actions, ui } = this.props
    const input = e.target
    const userState = {}
    const uiErrors = (ui.errors || []).filter(e => e.fieldName !== input.name)

    userState[input.name] = input.value

    actions.setUser(userState)
    actions.setUIState(containerIds.BUSINESS_SIGNUP, {
      hasError: false,
      errors: uiErrors,
    })
  }

  onClickNext = () => {
    this.props.validateUserSignup()
  }

  render() {
    const { company, user, actions, ui, data, location, isShow } = this.props
    const currentUser = data.viewer
    const buttonText = ui.hasError
      ? i18n.t('page.shared.l_00032')
      : i18n.t('page.signup.inputCorpInformation')
    const buttonClass = `button-green mt20 pt15 pb15 w300 sm-w100`

    const uiErrors = ui.errors || []

    return (
      <SignupFormWrapper className="signup-box" isShow={isShow}>
        <div className="row">
          <div className="col-xs-12">
            {!currentUser && (
              <div>
                <h2 className="signup-box__title signup-box__title-other">
                  {i18n.t('page.shared.registerAccount')}
                </h2>
                <p className="business-signup__description">
                  法人アカウントへログイン時に入力する情報となります。
                </p>
              </div>
            )}
            <div className="signup-box__wrapper-form">
              <div className="row signup-box__md-top">
                {!currentUser && (
                  <div>
                    <div className="col-sm-12 col-md-6">
                      <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label w100pa">
                        <input
                          className="mdl-textfield__input"
                          type="text"
                          id="familyName"
                          value={user.familyName}
                          onChange={this.onUserChange}
                          name="familyName"
                        />
                        <label
                          className="mdl-textfield__label"
                          htmlFor="familyName"
                        >
                          {i18n.t('page.shared.l_00059')}
                        </label>
                      </div>
                      {renderUIError.signupError('familyName', uiErrors)}
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label w100pa">
                        <input
                          className="mdl-textfield__input"
                          type="text"
                          id="givenName"
                          value={user.givenName}
                          onChange={this.onUserChange}
                          name="givenName"
                        />
                        <label
                          className="mdl-textfield__label"
                          htmlFor="givenName"
                        >
                          {i18n.t('page.shared.l_00060')}
                        </label>
                      </div>
                      {renderUIError.signupError('givenName', uiErrors)}
                    </div>
                    <div className="col-sm-12">
                      <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label w100pa">
                        <input
                          className="mdl-textfield__input"
                          type="text"
                          id="email"
                          value={user.email}
                          onChange={this.onUserChange}
                          name="email"
                        />
                        <label className="mdl-textfield__label" htmlFor="email">
                          {i18n.t('page.shared.l_00046')}
                        </label>
                      </div>
                      {renderUIError.signupError('email', uiErrors)}
                    </div>
                    <div className="col-sm-12">
                      <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label w100pa">
                        <input
                          className="mdl-textfield__input"
                          type="password"
                          id="password"
                          value={user.password}
                          onChange={this.onUserChange}
                          name="password"
                        />
                        <label
                          className="mdl-textfield__label"
                          htmlFor="password"
                        >
                          {i18n.t('page.shared.l_00061')}
                        </label>
                      </div>
                      {renderUIError.signupError('password', uiErrors)}
                    </div>
                    <div className="col-sm-12">
                      <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label w100pa">
                        <input
                          className="mdl-textfield__input"
                          type="password"
                          id="passwordConfirmation"
                          value={user.passwordConfirmation}
                          onChange={this.onUserChange}
                          name="passwordConfirmation"
                        />
                        <label
                          className="mdl-textfield__label"
                          htmlFor="passwordConfirmation"
                        >
                          {i18n.t('page.shared.l_00062')}
                        </label>
                      </div>
                      {renderUIError.signupError(
                        'passwordConfirmation',
                        uiErrors,
                      )}
                    </div>
                  </div>
                )}
                <div className="col-sm-12 ta-c">
                  <input
                    type="button"
                    name="commit"
                    value={buttonText}
                    className={buttonClass}
                    onClick={this.onClickNext}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {ui.hasError && (
          <p className="business-reservation-setting__feedback-error">
            {i18n.t('page.shared.l_00035')}
          </p>
        )}
      </SignupFormWrapper>
    )
  }
}

const SignupFormWrapper = styled.div`
  ${({ isShow }) =>
    isShow
      ? `
    display: block;
  `
      : `
    display: none;
  `};
`
